module.exports = __webpack_public_path__ + "img/chevron-down.ae27cb33.svg";